import { render, staticRenderFns } from "./IconCompletedLinear.vue?vue&type=template&id=5671e4b8&scoped=true"
import script from "./IconCompletedLinear.vue?vue&type=script&lang=js"
export * from "./IconCompletedLinear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5671e4b8",
  null
  
)

export default component.exports